import { render } from "./BenefitData.vue?vue&type=template&id=e58bdd48&scoped=true"
import script from "./BenefitData.vue?vue&type=script&lang=js"
export * from "./BenefitData.vue?vue&type=script&lang=js"

import "./BenefitData.vue?vue&type=style&index=0&id=e58bdd48&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e58bdd48"]])

export default __exports__